import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../shared/utilities/api.service";
import { Discussion, Comment } from "../../models";

@Injectable()
export class CommentVoteService {
  constructor(private apiService: ApiService) {}

  public upvote(discussion: Discussion, comment: Comment): Observable<Comment> {
    // POST /api/discussions/:community/:discussion/comments/:comment/vote?type=upvote
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const commentId = comment.id;
    const putURL = `/discussions/${communityName}/${discussionSlug}/comments/${commentId}/vote?type=upvote`;

    return this.apiService.post(putURL);
  }

  public downvote(
    discussion: Discussion,
    comment: Comment
  ): Observable<Comment> {
    // POST /api/discussions/:community/:discussion/comments/:comment/vote?type=downvote
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const commentId = comment.id;
    const putURL = `/discussions/${communityName}/${discussionSlug}/comments/${commentId}/vote?type=downvote`;

    return this.apiService.post(putURL);
  }
}
